import React from "react";
import YoutubePlayer from "../Player/YoutubePlayer";
import { getYoutubeEmbedUrl } from "@/utils/youtube";
import dynamic from "next/dynamic";
import Image from "next/image";
const Modal = dynamic(() => import("antd/es/modal"), { ssr: false });

export default function ReviewModal({ modalOpen, closeModal, selectedStory }) {
  return (
    <Modal
      open={modalOpen}
      onCancel={closeModal}
      footer={null}
      width={800}
      className="video-modal"
      centered
      destroyOnHidden
    >
      {selectedStory?.type === "Image" ? (
        <Image
          src={selectedStory?.image || "/placeholder.png"}
          alt="story image"
          width={800}
          height={450}
          className="rounded-lg object-contain"
        />
      ) : selectedStory?.type === "Text" ? (
        <div
          className="prose max-w-full overflow-auto"
          dangerouslySetInnerHTML={{
            __html: selectedStory?.description || "<p>কোনো রিভিউ নেই</p>",
          }}
        />
      ) : (
        <p className="text-base text-center">কোনো রিভিউ নেই</p>
      )}
    </Modal>
  );
}
